import { setCurrentView } from "../../../../redux/assignCourse/actions";
import AssignCourseModal from "../../../modal/AssignCourseModal";
import TagGroup from "../DetailTagGroup/TagGroup";
import AvailableInLPComponent from "./AvailableInLP/AvailableInLPComponent";
import "./RightPanelComponent.scss";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import CourseAds from "./CourseAds";
import { useTranslation } from "react-i18next";
const RightPanelComponent = (props) => {
  const {
    id,
    code,
    type,
    source,
    moduleData,
    parentName,
    isMobile,
    isRightPanel,
    isTagAvailable,
    from,
  } = props;

  const userRole = useSelector((state) => state.user.role);
  const authBroker = useSelector((state) => state.auth.authBroker);
  console.log("module data--", moduleData, userRole);
  const [show, setShow] = useState(false);
  let dispatch = useDispatch();
  let navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <>
      <div className="right-panel">
        {true || type === "event" ? (
          ""
        ) : (userRole === "manager" &&
            ((!moduleData?.isPaid &&
              moduleData?.purchased_info?.selling_price === 0 &&
              moduleData?.purchased_info?.is_purchased !== true) ||
              source === "broker")) ||
          (userRole === "manager" &&
            (type === "lp" || type === "oblp") &&
            source === "broker") ||
          (userRole === "manager" &&
            (type === "lp" || type === "oblp") &&
            moduleData?.purchased_info?.is_purchased !== true &&
            moduleData?.purchased_info?.selling_price === 0) ? (
          <div className="team-assign-sec  mt-xl-0 mt-5">
            <div className="text-box-rs d-flex align-items-center">
              <div className="img-leftbef">
                <img src="/images/TeamBenefit.svg" />
              </div>
              <div className="benefot">
                <p className="m-0">
                  {t("Get your team to benefit from this course")}
                </p>
              </div>
            </div>
            <div className="button-sec-assign mt-3 d-flex gap-2 align-items-center">
              <button
                type="button"
                className="startcourse-btn"
                onClick={() => {
                  dispatch(setCurrentView(1));
                  setShow(true);
                }}
              >
                + {t("Assign")}
              </button>

              <button
                type="button"
                className="startcourse-btn"
                onClick={() => {
                  let parentId = moduleData?.id;
                  let origin =
                    source === "xsel" || source === "ecom" ? "xsel" : "broker";
                  let pName =
                    type === "lp"
                      ? "learningpath"
                      : type === "oblp"
                      ? "onboardingpath"
                      : parentName;
                  navigate(
                    "/assigned-users?parentId=" +
                      parentId +
                      "&origin=" +
                      origin +
                      "&parentName=" +
                      pName +
                      "&isMobile=" +
                      isMobile //isMobile
                  );
                }}
              >
                {t("View Assigned")}
              </button>
            </div>
          </div>
        ) : (
          ""
        )}

        {(type === "course" ||
          type === "lp" ||
          type === "oblp" ||
          type === "video") &&
          authBroker.payload?.user?.config?.marketing_banner === "true" && (
            <CourseAds />
          )}

        <TagGroup {...props} />
        {type === "lp" ||
        type === "oblp" ||
        type === "service" ||
        type === "event" ? (
          ""
        ) : from === "module" ? (
          isRightPanel || isTagAvailable ? (
            <div className="mt-5">
              <AvailableInLPComponent {...props} />
            </div>
          ) : (
            ""
          )
        ) : (
          <div className="mt-5">
            <AvailableInLPComponent {...props} />
          </div>
        )}
      </div>

      <AssignCourseModal
        show={show}
        parentName={
          type === "lp"
            ? "Action Path"
            : type === "oblp"
            ? "Onboarding Path"
            : parentName
        }
        parentId={moduleData?.id}
        setShow={setShow}
        origin={source === "xsel" || source === "ecom" ? "xsel" : "broker"}
        isMobile={isMobile}
      />
    </>
  );
};

export default RightPanelComponent;
